<template>
    <div>
        <div class="d-lg-none">
            <div class="dropdown" v-if="isLoggedIn">
                <div class="d-block text-center flex-wrap dropdown-toggle" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <svg width="18" height="20"><use xlink:href="#svg_new-user" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>
                    <span>{{ $translate("Froschkoenig::Template.headerMyAccount") }}</span>
                </div>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <a :href="$ceres.urls.myAccount" class="dropdown-item">{{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="dropdown-item" v-logout>{{ $translate("Ceres::Template.loginLogout") }}</a>
                    <a href="/wish-list" class="dropdown-item">{{ $translate("Froschkoenig::Template.headerWishlist") }}</a>
                </div>
            </div>
            <div v-if="!isLoggedIn">
                <div class="d-block text-center flex-wrap dropdown-toggle" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <svg width="18" height="20"><use xlink:href="#svg_new-user" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>
                    <span>{{ $translate("Froschkoenig::Template.headerMyAccount") }}</span>
                </div>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <a class="dropdown-item" data-toggle="modal" href="#login" @click="createLoginModal(); unmarkInputFields();">{{ $translate("Froschkoenig::Template.headerLogin") }}</a>
                    <a class="dropdown-item" data-toggle="modal" href="#registration" @click="createRegisterModal(); unmarkInputFields();">{{ $translate("Froschkoenig::Template.headerRegister") }}</a>
                    <a href="/wish-list" class="dropdown-item">{{ $translate("Froschkoenig::Template.headerWishlist") }}</a>
                </div>
            </div>
        </div>
        <div class="d-none d-lg-block">
            <div class="dropdown" v-if="isLoggedIn">
                <div class="dropdown-toggle" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <a :href="$ceres.urls.myAccount"><svg width="13" height="15"><use xlink:href="#svg_new-user" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>{{ $translate("Froschkoenig::Template.headerMyAccount") }}</a>
                </div>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <a :href="$ceres.urls.myAccount" class="dropdown-item">{{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="dropdown-item" v-logout>{{ $translate("Ceres::Template.loginLogout") }}</a>
                    <a href="/wish-list" class="dropdown-item">Merkliste</a>
                </div>
            </div>
            <div v-if="!isLoggedIn">
                <div class="dropdown-toggle" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <a :href="$ceres.urls.myAccount"><svg width="13" height="15"><use xlink:href="#svg_new-user" xmlns:xlink="https://www.w3.org/1999/xlink"></use></svg>{{ $translate("Froschkoenig::Template.headerMyAccount") }}</a>
                </div>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <a class="dropdown-item" data-toggle="modal" href="#login" @click="createLoginModal(); unmarkInputFields();">{{ $translate("Froschkoenig::Template.headerLogin") }}</a>
                    <a class="dropdown-item" data-toggle="modal" href="#registration" @click="createRegisterModal(); unmarkInputFields();">{{ $translate("Froschkoenig::Template.headerRegister") }}</a>
                    <a href="/wish-list" class="dropdown-item">{{ $translate("Froschkoenig::Template.headerWishlist") }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    created()
    {
        ApiService.get("/rest/io/customer", {}, { keepOriginalResponse: true })
            .done(response =>
            {
                if (isDefined(response.data))
                {
                    this.$store.commit("setUserData", response.data);
                }
            });

        this.isLogin = App.templateType === "login";
        this.isRegister = App.templateType === "register";
    },

    /**
     * Add the global event listener for login and logout
     */
    mounted()
    {
        this.$nextTick(() =>
        {
            this.addEventListeners();
        });
    },

    methods: {
        /**
         * Adds login/logout event listeners
         */
        addEventListeners()
        {
            ApiService.listen("AfterAccountAuthentication", userData =>
            {
                this.$store.commit("setUserData", userData.accountContact);
            });

            ApiService.listen("AfterAccountContactLogout", () =>
            {
                this.$store.commit("setUserData", null);
            });
        },

        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");

        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
